import {  Divider, Grid, Paper, Typography } from "@mui/material";
import React, { useState } from "react";
import WSIconCard from "../../Components/IconCard/WSIconCard";
import { WSIcons } from "../../commonFunctions/iIcons";
import { useNavigate } from "react-router-dom";

export const BarRightSidebar: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate()

  const handleClick = (path:string)=>{
    navigate(path)
  }
  return (
    <Grid container spacing={2} sx={{ mt: 1 }}>
      <Grid item xs={12} sm={4}>
        <WSIconCard
          icon={<WSIcons.ReceiptIcon sx={{ color: "white" }} />}
          sx={{ height: "4rem", width: "9rem", backgroundColor: "green" }}
         />
      </Grid>
      <Grid item xs={12} sm={4}>
        <WSIconCard
          icon={<WSIcons.ReceiptIcon />}
          sx={{ height: "4rem", width: "9rem" }}
        />
      </Grid>
      <Grid item xs={12} sm={3}>
        <WSIconCard
          icon={<WSIcons.CloseIcon  sx={{ backgroundColor: "red", color: "white" }}/>}
          sx={{ height: "4rem", width: "8rem", backgroundColor: "red" }}
          onClick={()=>handleClick('/')}
        />
      </Grid>
      <Grid item xs={12} sx={{ backgroundColor: "lightgrey", mt: 1 }}>
        <Typography variant="h5" color={"green"}>
          Room 104
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Paper sx={{ p: 2 }}>
          <Grid
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            {/* Left aligned Sales Total label */}
            <Typography variant="body1" fontWeight="bold">
              Sales Total
            </Typography>
            {/* Right aligned amount */}
            <Typography variant="body1" fontWeight="bold" color="red">
              128.00
            </Typography>
          </Grid>
          <Divider />
          {/* Spacing between Sales Total and Guest Info */}
          <Grid sx={{ mt: 2 }}>
            {/* Guest Section */}
            <Grid display="flex" alignItems="center">
              {/* Left aligned Guest label */}
              <Typography variant="body1" fontWeight="bold" sx={{ mr: 5 }}>
                Guest:
              </Typography>
              {/* Right aligned guest name */}
              <Typography variant="body1">Andrew</Typography>
            </Grid>
          </Grid>
          <Divider />
          <Grid sx={{ mt: 2 }}>
            {/* Guest Section */}
            <Grid display="flex" alignItems="center">
              {/* Left aligned Guest label */}
              <Typography variant="body1" fontWeight="bold" sx={{ mr: 5 }}>
                KOT #
              </Typography>
              {/* Right aligned guest name */}
              <Typography variant="body1">1007 $</Typography>
            </Grid>
          </Grid>
          <Divider />

          <Grid sx={{ mt: 2 }}>
            {/* Guest Section */}
            <Grid container alignItems="center">
              <Grid
                item
                xs={8}
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
              >
                {/* Time and Name - Aligned Left */}
                <Typography variant="body1" fontWeight="bold" sx={{ mr: 1 }}>
                  2:49:43 PM
                </Typography>
                <Typography variant="body1">Roh</Typography>
              </Grid>

              {/* Amount - Aligned Right */}
              <Grid item xs={4} display="flex" justifyContent="flex-end">
                <Typography variant="body1">89.00</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Divider />

          <Grid sx={{ mt: 2 }}>
            {/* Guest Section */}
            <Grid container alignItems="center">
              <Grid
                item
                xs={8}
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
              >
                {/* Time and Name - Aligned Left */}
                <Typography variant="body1" fontWeight="bold" sx={{ mr: 4 }}>
                  2 glass
                </Typography>
                <Typography variant="body1">coffee Royal</Typography>
              </Grid>

              {/* Amount - Aligned Right */}
              <Grid item xs={4} display="flex" justifyContent="flex-end">
                <Typography variant="body1">30.00</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Divider />

          <Grid sx={{ mt: 2 }}>
            {/* Guest Section */}
            <Grid container alignItems="center">
              <Grid
                item
                xs={8}
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
              >
                {/* Time and Name - Aligned Left */}
                <Typography variant="body1" fontWeight="bold" sx={{ mr: 4 }}>
                  2 glass
                </Typography>
                <Typography variant="body1">Irish Coffee</Typography>
              </Grid>

              {/* Amount - Aligned Right */}
              <Grid item xs={4} display="flex" justifyContent="flex-end">
                <Typography variant="body1">30.00</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Divider />

          <Grid sx={{ mt: 2 }}>
            {/* Guest Section */}
            <Grid container alignItems="center">
              <Grid
                item
                xs={8}
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
              >
                {/* Time and Name - Aligned Left */}
                <Typography variant="body1" fontWeight="bold" sx={{ mr: 6 }}>
                  2 Pot
                </Typography>
                <Typography variant="body1">Pot Tea</Typography>
              </Grid>

              {/* Amount - Aligned Right */}
              <Grid item xs={4} display="flex" justifyContent="flex-end">
                <Typography variant="body1">8.00</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Divider />

          <Grid sx={{ mt: 2 }}>
            {/* Guest Section */}
            <Grid container alignItems="center">
              <Grid
                item
                xs={8}
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
              >
                {/* Time and Name - Aligned Left */}
                <Typography variant="body1" fontWeight="bold" sx={{ mr: 5 }}>
                  1 shot
                </Typography>
                <Typography variant="body1">Pernod</Typography>
              </Grid>

              {/* Amount - Aligned Right */}
              <Grid item xs={4} display="flex" justifyContent="flex-end">
                <Typography variant="body1">4.00</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Divider />

          <Grid sx={{ mt: 2 }}>
            {/* Guest Section */}
            <Grid container alignItems="center">
              <Grid
                item
                xs={8}
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
              >
                {/* Time and Name - Aligned Left */}
                <Typography variant="body1" fontWeight="bold" sx={{ mr: 5 }}>
                  1 shot
                </Typography>
                <Typography variant="body1">Montenegrone</Typography>
              </Grid>

              {/* Amount - Aligned Right */}
              <Grid item xs={4} display="flex" justifyContent="flex-end">
                <Typography variant="body1">6.00</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Divider />

          <Grid sx={{ mt: 2 }}>
            {/* Guest Section */}
            <Grid container alignItems="center">
              <Grid
                item
                xs={8}
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
              >
                {/* Time and Name - Aligned Left */}
                <Typography variant="body1" fontWeight="bold" sx={{ mr: 5 }}>
                  1 shot
                </Typography>
                <Typography variant="body1">Recard</Typography>
              </Grid>

              {/* Amount - Aligned Right */}
              <Grid item xs={4} display="flex" justifyContent="flex-end">
                <Typography variant="body1">4.00</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Divider />

          <Grid sx={{ mt: 2 }}>
            {/* Guest Section */}
            <Grid container alignItems="center">
              <Grid
                item
                xs={8}
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
              >
                {/* Time and Name - Aligned Left */}
                <Typography variant="body1" fontWeight="bold" sx={{ mr: 4 }}>
                  1 glass
                </Typography>
                <Typography variant="body1">Papaya Fresh Juice</Typography>
              </Grid>

              {/* Amount - Aligned Right */}
              <Grid item xs={4} display="flex" justifyContent="flex-end">
                <Typography variant="body1">7.00</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Divider />

          <Grid sx={{ mt: 2 }}>
            {/* Guest Section */}
            <Grid display="flex" alignItems="center">
              {/* Left aligned Guest label */}
              <Typography variant="body1" fontWeight="bold" sx={{ mr: 5 }}>
                Guest:
              </Typography>
              {/* Right aligned guest name */}
              <Typography variant="body1">John</Typography>
            </Grid>
          </Grid>
          <Divider />

          <Grid sx={{ mt: 2 }}>
            {/* Guest Section */}
            <Grid display="flex" alignItems="center">
              {/* Left aligned Guest label */}
              <Typography variant="body1" fontWeight="bold" sx={{ mr: 5 }}>
                KOT #
              </Typography>
              {/* Right aligned guest name */}
              <Typography variant="body1">10076 $</Typography>
            </Grid>
          </Grid>
          <Divider />

          <Grid sx={{ mt: 2 }}>
            {/* Guest Section */}
            <Grid container alignItems="center">
              <Grid
                item
                xs={8}
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
              >
                {/* Time and Name - Aligned Left */}
                <Typography variant="body1" fontWeight="bold" sx={{ mr: 1 }}>
                  2:52:16 PM
                </Typography>
                <Typography variant="body1">Roh</Typography>
              </Grid>

              {/* Amount - Aligned Right */}
              <Grid item xs={4} display="flex" justifyContent="flex-end">
                <Typography variant="body1">39.00</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Divider />

          <Grid sx={{ mt: 2 }}>
            {/* Guest Section */}
            <Grid container alignItems="center">
              <Grid
                item
                xs={8}
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
              >
                {/* Time and Name - Aligned Left */}
                <Typography variant="body1" fontWeight="bold" sx={{ mr: 4 }}>
                  1 glass
                </Typography>
                <Typography variant="body1">Irish Coffee</Typography>
              </Grid>

              {/* Amount - Aligned Right */}
              <Grid item xs={4} display="flex" justifyContent="flex-end">
                <Typography variant="body1">15.00</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Divider />

          <Grid sx={{ mt: 2 }}>
            {/* Guest Section */}
            <Grid container alignItems="center">
              <Grid
                item
                xs={8}
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
              >
                {/* Time and Name - Aligned Left */}
                <Typography variant="body1" fontWeight="bold" sx={{ mr: 4 }}>
                  1 glass
                </Typography>
                <Typography variant="body1">Jamaican Coffee</Typography>
              </Grid>

              {/* Amount - Aligned Right */}
              <Grid item xs={4} display="flex" justifyContent="flex-end">
                <Typography variant="body1">12.00</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Divider />

          <Grid sx={{ mt: 2 }}>
            {/* Guest Section */}
            <Grid container alignItems="center">
              <Grid
                item
                xs={8}
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
              >
                {/* Time and Name - Aligned Left */}
                <Typography variant="body1" fontWeight="bold" sx={{ mr: 4 }}>
                  1 glass
                </Typography>
                <Typography variant="body1">Mexican Coffee</Typography>
              </Grid>

              {/* Amount - Aligned Right */}
              <Grid item xs={4} display="flex" justifyContent="flex-end">
                <Typography variant="body1">12.00</Typography>
              </Grid>
            </Grid>
          </Grid>
          <Divider />
        </Paper>
      </Grid>
    </Grid>
  );
});
